import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {importLibrary, setOptions} from '@googlemaps/js-api-loader';
import {environment} from '../../../../environments/environment.development';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  apiLoaded: Promise<void> | null = null;
  #platformId: Object = inject(PLATFORM_ID);

  constructor() {
    if (isPlatformBrowser(this.#platformId)) {
      setOptions({
        key: environment.placesApi,
        v: 'weekly'
      });
    }
  }

  /**
   * Asynchronously loads the Google Maps Places library.
   *
   * The method ensures that the library is loaded only once,
   * even if called multiple times. The Promise is cached
   * for reuse on subsequent calls.
   *
   * @returns {Promise<void>} Promise that resolves when the Places library is loaded and ready to use.
   *
   * @throws {Error} If the API key is not configured or if loading fails.
   *
   * @example
   * ```typescript
   * // In a component
   * async ngOnInit() {
   *   try {
   *     await this.googleMapsService.loadPlacesApi();
   *     // The Places API is now available
   *   } catch (error) {
   *     console.error('Error loading Google Maps Places', error);
   *   }
   * }
   * ```
   */
  loadPlacesApi(): Promise<void> {
    if (!this.apiLoaded) {
      this.apiLoaded = importLibrary('places').then();
    }
    return this.apiLoaded;
  }

}
